type TValidPassword = boolean | string;

export const validatePassword = (password: string): TValidPassword => {
  const mediumPasswordRegEx =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*"'()+,-./:;<=>?[\]^_`{|}~])(?=.{8,})/;

  return mediumPasswordRegEx.test(password) || "Too weak";
};
